import Modal from 'shared/components/Modal'
import { isMobile } from 'shared/responsive-helpers'
import ErrorMessage from '@components/ErrorMessage'
import CircleLoader from '@components/CircleLoader'
import { RateCurrency } from 'shared/price-utilities'

const LoadingFallback = ({ cancelReservationPending, cancelAmendPolicyReservationPending }) => (
    <div className="d-flex justify-content-center align-items-baseline">
        <p style={{ marginRight: '10px' }}>
            {cancelAmendPolicyReservationPending && <T>reservation.cancel.cancellation-fee.loading</T>}
            {cancelReservationPending && <T>reservation.cancel.loading</T>}
        </p>
        <CircleLoader size="small" />
    </div>
)

const ConfirmationModal = ({
    reservationId,
    confirm,
    closeModal,
    cancellationData: { refundAmount, cancellationFee, currencySymbol },
    cancelReservationPending,
    cancelAmendPolicyReservationPending,
    initialAmountPaid,
    guestBooking,
    cancellationError,
}) => {
    const buttons = guestBooking
        ? [
              {
                  label: <T>manage.my.booking.modal.go.back.btn.label</T>,
                  onClick: closeModal,
                  btnClassName: 'brand-button--outline',
              },
              {
                  label: <T>manage.my.booking.modal.confirm.btn.label</T>,
                  onClick: confirm.bind(null, reservationId),
              },
          ]
        : [
              { label: <T>reservation.cancel.confirm.button.label</T>, onClick: confirm.bind(null, reservationId) },
              { label: <T>reservation.cancel.cancel.button.label</T>, onClick: closeModal },
          ]

    return (
        <Modal
            header={<T>reservation.cancel.confirm.question</T>}
            onClose={closeModal}
            size={guestBooking && (isMobile() ? 'small' : 'large')}
            ComponentLoadingFallback={() => (
                <LoadingFallback
                    cancelReservationPending={cancelReservationPending}
                    cancelAmendPolicyReservationPending={cancelAmendPolicyReservationPending}
                />
            )}
            loading={!cancellationError && (cancelReservationPending || cancelAmendPolicyReservationPending)}
            buttons={buttons}>
            <>
                {guestBooking && (
                    <div>
                        <T>manage.my.booking.initial.amount.label</T>{' '}
                        <RateCurrency value={initialAmountPaid || 0} currency={currencySymbol} />
                    </div>
                )}
                <div>
                    <T>reservation.cancel.refund-amount.label</T>{' '}
                    <RateCurrency value={refundAmount || 0} currency={currencySymbol} />
                </div>
                <div>
                    <T>reservation.cancel.cancellation-fee.label</T>{' '}
                    <RateCurrency value={cancellationFee || 0} currency={currencySymbol} />
                </div>
                {cancellationError && <ErrorMessage className="purchase-error" messages={[cancellationError]} />}
            </>
        </Modal>
    )
}

export default ConfirmationModal
